import React from "react";
import { BrowserRouter,Route, Routes, Navigate, useNavigate } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./styles/theme";
import { useAuth } from "./context/AuthContext";
import HomePagePinwheelAI from "./components/HomePagePinwheelAI";


const App = () => {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();

  if (loading) return <div>Loading...</div>;

  const handleLogout = async () => {
    await logout();
    navigate("/", { replace: true });
  };
return (
     
      <Routes>
        <Route path="/" element={<HomePagePinwheelAI />} />
      </Routes>
    //   <BrowserRouter>
    // </BrowserRouter>
  );
//   return (
//     <ThemeProvider theme={theme}>
//       <Routes>
//         // PUBLIC
// <Route path="/demo" element={<Navigate to="/demo/dashboard" replace />} />
// <Route path="/demo/dashboard" element={<DemoDashboard />} />
// <Route path="/demo/daily-sales" element={<DemoDailySales />} />
// <Route path="/demo/expenses" element={<DemoExpenses />} />
// <Route path="/demo/inventory" element={<DemoInventory />} />

//         <Route path="/" element={<HomePage />} />
//         <Route path="/SignUp" element={<SignUp />} />
//         <Route path="/invoice/:invoiceId" element={<PublicInvoiceView />} />
//         <Route path="/public-invoice/:invoiceId" element={<PublicInvoiceView />} />
//         <Route path="/track-order" element={<TrackOrder />} />
//         <Route path="/embroidery" element={<Embroidery />} />
//         <Route path="/stitching" element={<Stitching />} />

//         <Route
//           path="/expenses"
//           element={user ? <Expenses /> : <Navigate to="/" replace />}
//         />

//         <Route
//           path="/dashboard"
//           element={
//             user ? (
//               <Dashboard onSignOut={handleLogout} />
//             ) : (
//               <Navigate to="/" replace />
//             )
//           }
//         />
//         <Route path="/privacy-policy" element={<PrivacyPolicy />} />
//         <Route path="/demo" element={<PublicDemoDashboard />} />
//         <Route path="*" element={<NotFoundPage />} />
//       </Routes>
//     </ThemeProvider>
//   );
};

export default App;
